import { render, staticRenderFns } from "./CurrentGlyphEffect.vue?vue&type=template&id=731ba6a4&scoped=true&"
import script from "./CurrentGlyphEffect.vue?vue&type=script&lang=js&"
export * from "./CurrentGlyphEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ba6a4",
  null
  
)

export default component.exports